import {SensorReading} from "../../entities/SensorReadingHistory";
import {SensorStat} from "../../entities/SensorStatsHistory";
import {SensorService} from "../../services/SensorService";
import {SensorStatService} from "../../services/SensorStatService";
import { StateParams } from "@uirouter/angularjs";
import {LineChart, LineData, LinePair} from "./GraphCtrl";

export class AssetSensorHistoriesCtrl {
    public static $inject = ['$scope', '$q', '$stateParams', '$uibModal', 'SensorService', 'SensorStatService']
    sensorreading:SensorReading;
    sensorstat:SensorStat;
    sensorstats:SensorStat[] = [];
    sensorreadings:SensorReading[] = [];

    assetId:number;

    constructor(public $scope:any, public $q:ng.IQService, public stateParamsService:StateParams, public modal:angular.ui.bootstrap.IModalService,
                public sensorService:SensorService, public sensorstatService:SensorStatService) {
        $scope.vm = this;
        this.assetId = stateParamsService["id"];
        if (!this.assetId == null) {
            sensorService.getLastByAssetId(this.assetId).then((data)=> {
                this.sensorreading = data;
            })
            sensorstatService.getLastByAssetId(stateParamsService["id"]).then((data)=> {
                this.sensorstat = data;
            })
        }
    }
    srhGraph(prop:string){
        var promise = this.$q.when<SensorReading[]>([]);
        if(this.sensorreadings.length == 0){
            promise = this.sensorService.getByVTagId("007021");
        }
        promise.then((data)=> {
            if (data != null)
                this.sensorreadings = data;
            var lineItems:[string,string,string][] = [],
                chartName:string = "",
                xAxis:string = "created",
                yAxis:string = "";
            switch (prop) {
                case "minimumTemperatureDegC":
                case "maximumTemperatureDegC":
                    lineItems.push(["Min Temperature", "created", "minimumTemperatureDegC"])
                    lineItems.push(["Max Temperature", "created", "maximumTemperatureDegC"])
                    break;
                case "maximumAccelerationG":
                    lineItems.push(["Max Acceleration G", "created", "maximumAccelerationG"])
                    break;
                case "totalErrors":
                    lineItems.push(["Total Errors", "created", "totalErrors"])
                    break;
                case "batteryVolts":
                    lineItems.push(["Battery Volts", "created", "batteryVolts"])
                    break;
            }
            this.showGraph(this.sensorreadings, "", xAxis, yAxis, lineItems);
        });
    }
    sshGraph(prop:string){
        var promise = this.$q.when<SensorStat[]>([]);
        if(this.sensorstats.length == 0){
            promise = this.sensorstatService.getByVTagId("007021");
        }
        promise.then((data)=>{
            if(data != null)
                this.sensorstats = data;
            var lineItems:[string,string,string][] = [],
            chartName:string = "",
            xAxis:string = "created",
            yAxis:string = "";
            switch(prop){
                case "numNeighbors":
                    lineItems.push(["Num Neighbors","created","numNeighbors"])
                    break;
                case "ttl":
                    lineItems.push(["TTL","created","ttl"])
                    break;
                case "numActiveNeighbors":
                    lineItems.push(["Num Active Neighbors","created","numActiveNeighbors"])
                    break;
                case "totalErrors":
                    lineItems.push(["Total Errors","created","totalErrors"])
                    break;
                case "minQueue":
                case "maxQueue":
                    lineItems.push(["Min Queue","created","minQueue"])
                    lineItems.push(["Max Queue","created","maxQueue"])
                    break;
                case "avgQueue":
                    lineItems.push(["Average Queue","created","avgQueue"])
                    break;
                case "processedPackets":
                    lineItems.push(["Processed Packets","created","processedPackets"])
                    break;
                case "alarmCount":
                    lineItems.push(["Alarm Count","created","alarmCount"])
                    break;
                case "movementTriggers":
                    lineItems.push(["Movement Triggers","created","movementTriggers"])
                    break;
                case "leafDroppedPackets":
                    lineItems.push(["Leaf Dropped Packets","created","leafDroppedPackets"])
                    break;
                case "daysSinceReset":
                    lineItems.push(["Days Since Reset","created","daysSinceReset"])
                    break;
                case "firmwareVersion":
                    lineItems.push(["Firmware Version","created","firmwareVersion"])
                    break;
            }
            this.showGraph(this.sensorstats,"",xAxis,yAxis, lineItems);
        });
    }
    showGraph(data:any[],title:string,xAxis:string,yAxis:string, lineItems:[string,string,string][]){
        var lineDatas:LineData[] = [];
        for(var i=0;i<lineItems.length;i++){
            var lineItem:[string,string,string] = lineItems[i]
            var linePairs:LinePair[] = [];
            $.each(data,(i,val)=>{
                linePairs.push(
                    new LinePair(
                        val[lineItem[1]],
                        val[lineItem[2]]
                    )
                )
            });
            var lineData = new LineData(lineItem[0], linePairs);
            lineDatas.push(lineData);
        }
        var lineChart = new LineChart(title,xAxis, yAxis, lineDatas);
        var modalInstance:angular.ui.bootstrap.IModalServiceInstance = this.modal.open({
            animation: true,
            template: require('../../../views/graph.html').default,
            controller: 'GraphCtrl',
            size: 'lg',
            resolve: {
                lineChart: function () {
                    return lineChart;
                }
            }
        });

        return modalInstance.result;
    }

}
